import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import { Stack, Typography } from '@mui/material';
import PaiSpinningLoader from 'features/ui/base-components/pai-spinning-loader';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  loading: boolean;
  transcript: string;
}

const Transcript: React.FC<Props> = ({ loading, transcript }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.transcript}>
      {loading ? (
        <Stack className={classes.loadingContainer} justifyContent={'center'} alignItems={'center'}>
          <PaiSpinningLoader size={'large'} />
        </Stack>
      ) : null}
      <Stack className={classes.sectionIndicator} direction={'row'} alignItems={'center'}>
        <div className={classes.line} />
        <ContentPasteIcon className={classes.icon} />
        <Typography className={classes.sectionTitleText}>{t('callTranscript')}</Typography>
      </Stack>
      <Stack className={classes.textContainer} gap={2}>
        <Typography style={{ whiteSpace: 'pre-wrap' }}>{transcript}</Typography>
      </Stack>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  transcript: {
    position: 'relative',
    background: theme.palette.backgrounds.main_new,
    padding: 'calc(32px + 32px + 56px) 64px 32px 64px',
    borderRadius: '10px',
  },
  loadingContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#FFF',
    opacity: 0.8,
    zIndex: 90,
  },
  sectionIndicator: {
    position: 'absolute',
    left: 0,
    top: '32px',
  },
  line: {
    background: theme.palette.primary.main,
    height: '2px',
    width: '64px',
  },
  icon: {
    fontSize: theme.typography.pxToRem(32),
    background: theme.palette.primary.main,
    borderRadius: '50%',
    color: '#FFF',
    padding: '4px',
  },
  sectionTitleText: {
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    marginLeft: '16px',
  },
  textContainer: {
    borderRadius: '10px',
    background: '#FFF',
    padding: '16px',
  },
}));

export default Transcript;
